var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiftManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#4e8482;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,13.87c.28-.63,.78-.83,1.45-.83,5.09,.01,10.19,0,15.28,0h.66v-.64c0-3.65,0-7.29,0-10.94,0-1.09,.38-1.47,1.46-1.47,4.1,0,8.2,0,12.3,0,1.09,0,1.46,.38,1.46,1.47,0,3.65,0,7.29,0,10.94v.65h.65c5.03,0,10.06,0,15.09,0,.16,0,.33,0,.49,0,.74,.05,1.15,.44,1.15,1.18,.01,2.83,.01,5.66,0,8.49,0,.76-.46,1.18-1.24,1.19-1.01,.01-2.02,0-3.06,0v23.92c.93,0,1.83,0,2.74,0,.23,0,.46,0,.68,.03,.48,.09,.78,.4,.86,.88,.08,.46-.1,.83-.5,1.08-.11,.07-.23,.12-.34,.18H.88c-.43-.16-.73-.44-.88-.88v-.49c.29-.62,.79-.83,1.46-.81,.94,.04,1.88,0,2.86,0V23.92c-.99,0-1.95-.01-2.9,0-.68,.01-1.17-.22-1.41-.88V13.87ZM6.55,47.8H43.45V23.96H6.55v23.84ZM47.82,15.25H2.2v6.45H47.82v-6.45ZM30.43,2.2h-10.84V13h10.84V2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M25.03,30.44c3.48,0,6.97,0,10.45,0,1.14,0,1.48,.34,1.48,1.48,0,2.64,0,5.27,0,7.91,0,1.11-.36,1.47-1.45,1.47-7,0-14,0-21,0-1.1,0-1.46-.36-1.46-1.47,0-2.65,0-5.3,0-7.96,0-1.08,.35-1.44,1.43-1.44,3.52,0,7.03,0,10.55,0Zm-9.79,8.66h19.51v-6.46H15.24v6.46Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftManagement);
export default __webpack_public_path__ + "static/media/Shift Management.5491e99c0b7be2fc7a3c8eec1b6339a3.svg";
export { ForwardRef as ReactComponent };